import { WidgetConfig } from '../../../models/widget.config';

export class TextAreaWidgetConfig extends WidgetConfig<string> {
  widgetType = 'TextAreaWidget';
  constructor(config) {
    super(config);
  }
}
